import React from 'react';
import { Container, Eyebrow, H2, Reveal } from './shared';
import { ApplicationForm } from './ApplicationForm';

const STEPS = [
  { title: 'Kurz bewerben', text: 'Ein paar Fragen zu dir und deinem Ziel. Dauert keine 2 Minuten.' },
  { title: 'Kennenlern-Call mit mir', text: 'Innerhalb von 48 Stunden melde ich mich persönlich. Wir schauen ehrlich, ob das Mentoring zu dir passt.' },
  { title: 'Start deiner 4 Wochen', text: 'Du bekommst alle Unterlagen, und wir legen mit dem ersten Call los.' },
];

export const Apply = () => (
  <section id="bewerbung" className="relative scroll-mt-20 bg-paper py-20 sm:py-28" data-testid="apply-section">
    <Container className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20">
      <Reveal>
        <Eyebrow>So läuft's ab</Eyebrow>
        <H2>In drei Schritten dabei</H2>
        <ol className="mt-10 space-y-8">
          {STEPS.map((s, i) => (
            <li key={s.title} className="flex gap-5" data-testid={`apply-step-${i + 1}`}>
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-leaf font-display text-lg font-extrabold text-brand">{i + 1}</span>
              <div>
                <h3 className="font-display text-xl font-bold text-white">{s.title}</h3>
                <p className="mt-1.5 text-[15px] leading-relaxed text-ink sm:text-base">{s.text}</p>
              </div>
            </li>
          ))}
        </ol>
      </Reveal>
      <Reveal delay={100}><ApplicationForm /></Reveal>
    </Container>
  </section>
);
